import React, { useContext } from 'react'
import {
  Snackbar as MatSnackbar,
  SnackbarCloseReason,
  SnackbarOrigin
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { SnackbarContext } from 'contexts/SnackbarContext'

const AUTO_HIDE_DURATION = 3 * 1000 // 3 sec
const anchorOrigin: SnackbarOrigin = {
  vertical: 'top',
  horizontal: 'center'
}

const Snackbar: React.FC = () => {
  const { toast, closeToast } = useContext(SnackbarContext)

  const handleClose = (
    event: React.SyntheticEvent<any, Event>,
    reason: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') return
    closeToast()
  }

  return (
    <MatSnackbar
      anchorOrigin={anchorOrigin}
      open={Boolean(toast.message)}
      autoHideDuration={toast.timeout || AUTO_HIDE_DURATION}
      onClose={handleClose}
    >
      <Alert onClose={closeToast} severity={toast.severity}>
        {toast.message}
      </Alert>
    </MatSnackbar>
  )
}

export default Snackbar
